/**
 * The boolean check on the passed in value.
 */
export function coerceBooleanProperty(value: any): boolean {
    return value != null && `${value}` !== 'false';
}
